import { render } from "./CopyFormatMenu.vue?vue&type=template&id=6e942353&scoped=true"
import script from "./CopyFormatMenu.vue?vue&type=script&lang=js"
export * from "./CopyFormatMenu.vue?vue&type=script&lang=js"

import "./CopyFormatMenu.vue?vue&type=style&index=0&id=6e942353&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e942353"]])

export default __exports__